import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  errorNotification,
  loadingNotification,
  updateToError,
  updateToSuccessNotification,
} from "Components/MyNotification";
import WorksApi from "Api/WorksApi/WorksApi";

export const getAllWorksThunk = createAsyncThunk(
  "works/getAllWorks",
  async (data, thunkAPI) => {
    try {
      const page = data?.page || 1;
      const searchValue = data?.searchValue || "";
      const result = await WorksApi.getAllWorks(page, searchValue);
      if (result.status === "fail") {
        errorNotification(result.message);
        return thunkAPI.rejectWithValue(result.message);
      }
      if (result.status === "success") {
        return result.dto;
      }
    } catch (err) {
      errorNotification(err.message);
      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const updateWorkThunk = createAsyncThunk(
  "works/updateWork",
  async (workData, thunkAPI) => {
    const toastId = loadingNotification("Оновлення роботи...");
    try {
      const result = await WorksApi.updateWork(workData);

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }

      updateToSuccessNotification(toastId, "Роботу успішно оновлено");
      await thunkAPI.dispatch(getAllWorksThunk());
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка оновлення");

      return thunkAPI.rejectWithValue(err);
    }
  },
);
export const createWorkThunk = createAsyncThunk(
  "works/createWorkRegistration",
  async (workData, thunkAPI) => {
    const toastId = loadingNotification("Створення користувача...");

    try {
      const result = await WorksApi.createWork(workData);

      if (result.status === "fail") {
        updateToError(toastId, result.message);
        return thunkAPI.rejectWithValue(result.message);
      }

      updateToSuccessNotification(toastId, "Створено нову роботу");
      await thunkAPI.dispatch(getAllWorksThunk());
      return result.dto;
    } catch (err) {
      updateToError(toastId, err.message || "Помилка створення");
      return thunkAPI.rejectWithValue(err);
    }
  },
);

const initialState = {
  isLoading: false,
  worksList: [],
  currentPage: 1,
  totalPages: 1,
  total: 1,
};

const WorksSlice = createSlice({
  name: "works",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllWorksThunk.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getAllWorksThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      const { total, data, currentPage, totalPages } = action.payload;
      state.worksList = data;
      state.currentPage = currentPage;
      state.total = total;
      state.totalPages = totalPages;
    });
    builder.addCase(getAllWorksThunk.rejected, (state, action) => {
      state.isLoading = false;
    });
  },
});

export const {} = WorksSlice.actions;
export const selectWorks = (store) => store.works;

export default WorksSlice.reducer;
